import * as THREE from './lib/three.min';

window.THREE = THREE;
